import { render, staticRenderFns } from "./EmptyWallet.vue?vue&type=template&id=dbd00028"
import script from "./EmptyWallet.vue?vue&type=script&lang=js"
export * from "./EmptyWallet.vue?vue&type=script&lang=js"
import style0 from "./EmptyWallet.vue?vue&type=style&index=0&id=dbd00028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports